import { Component, OnInit} from '@angular/core';
import { AtlasDescriptionBaseComponent } from '../atlas-description-base.component';
import { TranslationHelperService } from 'src/app/services/translations/translation-helper.service';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-atlas-mobile-description',
  templateUrl: './atlas-mobile-description.component.html',
  styleUrls: ['./atlas-mobile-description.component.scss']
})
export class AtlasMobileDescriptionComponent extends AtlasDescriptionBaseComponent implements OnInit {

  constructor(
    protected translationHelperService: TranslationHelperService,
    protected _router: Router
  ) { super(translationHelperService, _router) }

  ngOnInit(): void {
  }

}




